import { useAction } from 'convex/react';
import { api } from 'convex/_generated/api';

export function useChangePassword() {
  return useAction(api.password.actions.changePassword);
}
